import sanitize from "sanitize-html";

const sanitizeHTML = (element: string) => {
  return sanitize(element, {
    allowedTags,
    allowedAttributes,
  });
};

const allowedTags = [
  "svg",
  "path",
  "g",
  "mask",
  "rect",
  "defs",
  "clipPath",
  "ul",
  "li",
  "span",
  "br",
  "b",
];

const svgAttr = [
  "width",
  "height",
  "viewBox",
  "viewbox",
  "xmlns",
  "x",
  "y",
  "width",
  "height",
  "d",
  "style",
  "maskUnits",
  "mask-type",
  "id",
  "version",
  "xmlns:cc",
  "xmlns",
  "transform",
  "fill",
];

const allowedAttributes = {
  svg: svgAttr,
  path: svgAttr,
  rect: svgAttr,
  g: svgAttr,
  clipPath: svgAttr,
  ul: ["class"],
  span: ["class"],
  b: ["style"],
};

export default sanitizeHTML;
